var map = {
	"./voice0.mp3": 9411,
	"./voice1.wav": 3204,
	"./voice2.mp3": 900,
	"./voice3.m4a": 2277,
	"./voice4.m4a": 539,
	"./voice5.mp3": 6742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3046;